<template>
  <div>
    <v-autocomplete
      :items="estabelecimentos"
      :loading="loading"
      :search-input.sync="search"
      :item-text="formatNome"
      item-value="id"
      label="Nome do Estabelecimento"
      hide-no-data
      hide-selected
      return-object
      v-model="model"
      @change="selecionarEstabelecimento"
    />
    <v-chip 
      v-for="e in estabelecimentosSelecionados"
      :key="e.id"
      close
      @input="removerEstabelecimentoSelecionado(e.id)"
    >{{ e.nome_loja }}</v-chip>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'FiltroNomeEstabelecimento',
  data() {
    const estabelecimentosInitial = [
      {
        id: null,
        nome_loja: 'Todos os estabelecimentos'
      }
    ]
    return {
      estabelecimentosInitial,
      estabelecimentos: estabelecimentosInitial,
      estabelecimentosSelecionados: [],
      model: null,
      loading: false,
      buscador: null,
      search: null,
      selected: false
    }
  },
  watch: {
    search() {
      if (this.search === 'Todos os estabelecimentos') {
        return
      }
      if (this.selected) {
        this.selected = false
        return
      }
      if (this.buscador !== null) {
        clearTimeout(this.buscador)
      }
      this.buscador = setTimeout(this.buscarEstabelecimentos, 1000)
    },
  },
  methods: {
    async buscarEstabelecimentos() {
      let estabelecimentos
      try {
        this.loading = true
        this.estabelecimentos = this.estabelecimentosInitial
        if (this.search !== null && this.search.length > 0) {
          const response = await api.post('/', {
            query: `{ estabelecimentosPeloNome(nome: "${this.search}") { id nome_loja cpf_cnpj } }`
          })
          estabelecimentos = response.data.data.estabelecimentosPeloNome
        }
      }
      catch {
        estabelecimentos = []
      }
      finally {
        this.estabelecimentos = this.estabelecimentos.concat(estabelecimentos)
        this.loading = false
      }
    },
    selecionarEstabelecimento(value) {
      if (value === undefined) {
        return
      }
      else if (value.id === null) {
        this.estabelecimentosSelecionados = this.estabelecimentosInitial
      }
      else {
        if (this.estabelecimentosSelecionados.length > 0 && this.estabelecimentosSelecionados[0].id === null) {
          this.estabelecimentosSelecionados = []
        }
        this.estabelecimentosSelecionados.push(value)
      }
      this.emitirEstabelecimentosSelecionados()
      this.selected = true
    },
    removerEstabelecimentoSelecionado(id) {
      if (id === null) {
        return
      }
      this.estabelecimentosSelecionados = this.estabelecimentosSelecionados.filter(e => e.id !== id)
      this.emitirEstabelecimentosSelecionados()
    },
    emitirEstabelecimentosSelecionados() {
      let lista = this.estabelecimentosSelecionados.slice()
      if (lista.length > 0 && lista[0].id === null) {
        lista.splice(0, 1)
      }
      let retorno = []
      for (let i = 0; i < lista.length; i ++) {
        retorno.push(lista[i].id);
      }
      this.$emit('filtrar-estabelecimentos', { 
        ids: retorno 
      })
    },
    formatNome(estabelecimento) {
      const {
        cpf_cnpj,
        nome_loja
      } = estabelecimento
      if (cpf_cnpj) {
        return `${nome_loja} - ${cpf_cnpj}`
      }
      return nome_loja
    }
  }
}
</script>
